<placeme-layout-seo [seo]="'blogsPage.seo' | translate">
  <placeme-jumbotron [seo]="'blogsPage.seo' | translate"></placeme-jumbotron>
  <section class="main-content blogs">
    <markdown class="page-markdown" [data]="'blogsPage.content' | translate"></markdown>

    <div class="blogs__container">
      <placeme-blog-card *ngFor="let item of blogs; trackBy: trackBySlug" [blog]="item"></placeme-blog-card>
    </div>
    <p *ngIf="blogs && !blogs.length" class="blogs__empty">{{ 'blogsPage.emptyContent' | translate }}</p>
  </section>
</placeme-layout-seo>
